/* Planetee — recommandations produit maison (remplace AI Recommendations+ / Softify).
   Principe : on extrait le THEME du produit courant (prenom, activite...) depuis son
   titre, puis on propose d'autres produits sur le meme theme — tous types confondus,
   pour donner de nouvelles idees au client.
     "Mug Coralie Definition Perfection" -> theme "coralie definition"
        -> Trousse / Sweat / Affiche / Sac Coralie...
   100 % natif Shopify (/search/suggest.json + /recommendations), 0 requete externe.
   Best-sellers remontes en premier via l'index otshirt-bs-index.json. */
(function () {
  "use strict";

  var WANTED = 10;        // nb de cartes visees
  var MIN_OK = 6;         // en dessous, on elargit la recherche
  var TITLE = "Vous aimerez aussi";
  var TITLE_HOME = "Nos meilleures ventes";

  // mots a retirer du titre : types de produits, declinaisons, remplissage.
  // (on GARDE les mots porteurs de theme : prenoms, papa, maman, noel, moto, camping...)
  var STOP = ("mug tasse chope biere verre bouteille isotherme gourde thermos " +
    "tshirt t-shirt tee shirt sweat capuche hoodie pull debardeur maillot polo pyjama " +
    "body bodys bavoir doudou peluche boxer calecon chaussettes chaussette " +
    "sac tote bag jute cabas trousse pochette tablier coussin housse " +
    "affiche poster tapis souris casquette bonnet porte-cle plaid serviette " +
    "planche couteau bougie magnet badge sticker autocollant lanterne veilleuse " +
    "femme homme enfant bebe unisexe fille garcon mixte adulte " +
    "blanc blanche noir noire beige bleu bleue rose gris grise rouge vert verte " +
    "jaune violet orange marron kaki bordeaux turquoise argent dore " +
    "personnalise personnalisee personnalisable prenom cadeau cadeaux idee " +
    "le la les un une des du de d l et a au aux en pour par avec sur " +
    "mon ma mes ton ta tes son sa ses ce cette qui que est c j " +
    // tournures ultra-frequentes du catalogue : elles diluent la recherche
    "peux pas ai jai genial geniale geniaux super merci formidable " +
    "meilleur meilleure meilleurs meilleures monde tous temps").split(" ");
  var STOPSET = {};
  STOP.forEach(function (w) { STOPSET[w] = 1; });

  // mots qui completent un nom de produit ("tablier DE CUISINE", "chope de BIERE",
  // "sac de PLAGE", "planche a DECOUPER"...). On ne les retire qu'en DEBUT de titre :
  // ailleurs ils peuvent porter le theme ("J'peux pas j'ai cuisine").
  var LEAD_EXTRA = ("cuisine biere plage jute decouper pliant corde anse souris " +
    "bain sport nuit toilette maquillage manches longues courtes capuche").split(" ");
  var LEADSET = {};
  STOP.concat(LEAD_EXTRA).forEach(function (w) { LEADSET[w] = 1; });

  var bs = null, bsList = null, bsUrl = null;
  var scriptEl = document.currentScript;
  if (scriptEl) bsUrl = scriptEl.getAttribute("data-bsindex");

  function norm(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  }
  function esc(s) { var d = document.createElement("div"); d.textContent = s || ""; return d.innerHTML; }

  function currentHandle() {
    var m = /\/products\/([^/?#]+)/.exec(location.pathname);
    return m ? m[1] : "";
  }

  /* Titre -> jusqu'a 2 mots-clefs porteurs de theme.
     Ex. "Tablier de cuisine Pizza J'peux pas" -> ["pizza"]  (et non "cuisine pizza",
     qui ne ramenait que des tabliers). */
  function keywords() {
    var h1 = document.querySelector("h1");
    var raw = (h1 && h1.textContent) || document.title || "";
    raw = raw.split("|")[0];  // coupe les suffixes SEO
    var words = norm(raw).replace(/[^a-z0-9\s-]/g, " ").split(/\s+/).filter(Boolean);
    // 1) on jette le nom du produit en tete de titre
    var i = 0;
    while (i < words.length && LEADSET[words[i]]) i++;
    if (i >= words.length) i = 0;  // titre 100 % type produit : on repart de zero
    // 2) sur le reste, on ne garde que les mots porteurs
    var out = [], seen = {};
    words.slice(i).forEach(function (w) {
      if (w.length < 3 && !/^\d+$/.test(w)) return;
      if (STOPSET[w] || seen[w]) return;
      seen[w] = 1; out.push(w);
    });
    return out;
  }

  function priceOf(p) {
    // suggest.json -> "24.99" | recommendations.json -> 2499 (centimes)
    var v = p.price;
    if (v == null) return "";
    if (typeof v === "number") v = v / 100;
    var n = parseFloat(v);
    return isNaN(n) ? "" : n.toFixed(2).replace(".", ",") + " €";
  }
  function imageOf(p) {
    var u = p.image || p.featured_image || (p.images && p.images[0]) || "";
    if (u && u.url) u = u.url;
    return u ? String(u).replace(/(\.[a-z]+)(\?|$)/i, "_300x$1$2") : "";
  }
  function shortTitle(t) {
    var s = (t || "").split(/\s[|–-]\s/)[0].trim();
    return s.length > 52 ? s.slice(0, 50).trim() + "…" : s;
  }
  function familyOf(t) { return norm(t).split(/\s+/)[0] || ""; }

  function suggest(q) {
    return fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=14" +
      "&resources[options][unavailable_products]=hide")
      .then(function (r) { return r.json(); })
      .then(function (d) { return ((((d || {}).resources || {}).results) || {}).products || []; })
      .catch(function () { return []; });
  }
  function related() {
    var id = (window.meta && window.meta.product && window.meta.product.id);
    if (!id) return Promise.resolve([]);
    return fetch("/recommendations/products.json?product_id=" + id + "&limit=10&intent=related")
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }

  /* best-sellers d'abord, puis variete de types (evite 8 mugs d'affilee) */
  function arrange(list) {
    var top = [], rest = [];
    list.forEach(function (p) {
      var h = (/\/products\/([^/?#]+)/.exec(p.url || "") || [])[1];
      (bs && h && bs[h] ? top : rest).push(p);
    });
    var ordered = top.concat(rest), used = {}, first = [], later = [];
    ordered.forEach(function (p) {
      var f = familyOf(p.title);
      if (!used[f]) { used[f] = 1; first.push(p); } else { later.push(p); }
    });
    return first.concat(later);
  }

  function render(products, heading) {
    if (products.length < 3) return;
    var sec = document.createElement("section");
    sec.className = "pl-reco";
    sec.innerHTML = '<h2 class="pl-reco__title">' + esc(heading || TITLE) + '</h2>' +
      '<div class="pl-reco__track">' + products.map(function (p) {
        var img = imageOf(p);
        return '<a class="pl-reco__card" href="' + p.url + '">' +
          '<span class="pl-reco__imgwrap">' +
          (img ? '<img class="pl-reco__img" loading="lazy" src="' + img + '" alt="">' : '') +
          '</span><span class="pl-reco__name">' + esc(shortTitle(p.title)) + '</span>' +
          '<span class="pl-reco__price">' + priceOf(p) + '</span></a>';
      }).join("") + '</div>';

    // On prend la place de la section « Nous vous recommandons également » du theme
    // (produits de la meme collection) : la notre propose le meme THEME de design.
    // Elle n'est masquee que si la notre s'affiche -> jamais de trou dans la page.
    var themeReco = document.querySelector(".cont-related");
    if (themeReco && themeReco.parentNode) {
      themeReco.parentNode.insertBefore(sec, themeReco);
      themeReco.style.display = "none";
      return;
    }
    var main = document.querySelector("main.main-content") ||
               document.querySelector("main") || document.body;
    main.appendChild(sec);
  }

  function collect() {
    var kw = keywords();
    if (!kw.length) return related().then(render);
    var here = currentHandle();
    var seen = {}, acc = [];
    function add(list) {
      list.forEach(function (p) {
        var h = (/\/products\/([^/?#]+)/.exec(p.url || "") || [])[1];
        if (!h || h === here || seen[h]) return;
        seen[h] = 1; acc.push(p);
      });
    }
    // 1) deux mots-clefs : le meilleur compromis pertinence / variete
    return suggest(kw.slice(0, 2).join(" ")).then(function (a) {
      add(a);
      if (acc.length >= MIN_OK || kw.length < 2) return;
      // 2) trop peu -> on elargit au mot-clef principal
      return suggest(kw[0]).then(add);
    }).then(function () {
      if (acc.length >= 4) return;
      // 3) filet de securite : moteur de reco natif Shopify
      return related().then(add);
    }).then(function () {
      render(arrange(acc).slice(0, WANTED));
    });
  }

  /* Accueil : les vraies meilleures ventes (index best-sellers) */
  function homeBestsellers() {
    if (!bsList || !bsList.length) return;
    render(bsList.slice(0, 12).map(function (it) {
      return { title: it.t, url: it.u, image: it.i, price: it.p };
    }), TITLE_HOME);
  }

  function init() {
    var isProduct = /\/products\//.test(location.pathname);
    var isHome = location.pathname === "/" || /^\/[a-z]{2}(-[a-z]{2})?\/?$/i.test(location.pathname);
    if (!isProduct && !isHome) return;
    var go = function () { isProduct ? collect() : homeBestsellers(); };
    if (!bsUrl) return isProduct ? go() : undefined;
    fetch(bsUrl).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (a) {
        if (Array.isArray(a)) {
          bsList = a;
          bs = {};
          a.forEach(function (it) {
            var h = (/\/products\/([^/?#]+)/.exec(it.u || "") || [])[1];
            if (h) bs[h] = 1;
          });
        }
      }).catch(function () {}).then(go);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
